import { useCallback } from 'react';
import { useSlider } from '@trinity/chat-components/components/Slider/hooks/useSlider';
import { SliderThumb } from '@trinity/chat-components/components/Slider/Thumb';
import { ActiveSliderTrack, InactiveSliderTrack } from '@trinity/chat-components/components/Slider/Tracks';
import { useAudioPlayerState } from '@trinity/chat-components/containers/AudioPlayer/Context';
import styles from './style/Progress.Track.module.css';

type Props = {
  style?: React.CSSProperties;
  scan: (time: number) => void;
  seek: (time: number) => void;
  position: number;
  className?: string;
};

export const AudioPlayerTrackProgress = ({ style = {}, position, scan, seek, className }: Props) => {
  const [{ duration }] = useAudioPlayerState();

  const handlePositionChange = useCallback(
    (p: number) => {
      scan(p);
    },
    [scan]
  );

  const handleDragEnd = useCallback(() => {
    seek(position);
  }, [seek, position]);

  const { activeTrackStyles, handleMouseDown, handleTouchStart, thumbStyles, sliderRef, thumbRef } =
    useSlider({
      incrementBy: 0.05,
      minValue: 0,
      maxValue: duration,
      onDragEnd: handleDragEnd,
      onPositionChange: handlePositionChange,
      value: position,
    });

  return (
    <div
      className={`${styles.track} ${className || ''}`}
      style={style}
      ref={sliderRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    >
      <ActiveSliderTrack className={styles.active} style={{ ...activeTrackStyles, ...style }} />
      <InactiveSliderTrack className={styles.inactive} style={style} />
      <SliderThumb ref={thumbRef} className={styles.thumb} style={{ ...thumbStyles, ...style }} />
    </div>
  );
};

export default AudioPlayerTrackProgress;
